import { Pipe, PipeTransform } from '@angular/core';
import { LocalDate } from '../types/local-date.type';

@Pipe({
	name: 'localDateToDate'
})
export class LocalDateToDatePipe implements PipeTransform {
	transform(localDate: LocalDate | undefined | null): Date | undefined | null {
		if (!localDate)
			return localDate;

		let year = localDate[0];
		let month = localDate[1];
		let day = localDate[2];
		let date = new Date(year, month - 1, day);

		return date;
	}
}